import {
  Grid,
  TextField,
  Typography,
  Box,
  InputAdornment,
} from "@mui/material";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme) => ({
  container: {
    // paddingLeft: 120,
    // paddingRight: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  numBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#1381b8",
    color: "#fff",
    fontWeight: 600,
  },
  captchaBox: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "center",
  },
}));
function Captcha({ errorMsg }, ref) {
  const [num1, setNum1] = useState(null);
  const [num2, setNum2] = useState(null);
  const [answer, setAnswer] = useState("");
  const classes = useStyles();

  useEffect(() => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
  }, []);

  const handleChange = (event) => {
    setAnswer(event.target.value);
  };

  const checkAnswer = () => {
    const sum = num1 + num2;
    if (parseInt(answer) === sum) {
      //   alert("Success!");
      return [true, answer];
    } else {
      //   alert("Error!");

      setNum1(Math.floor(Math.random() * 10) + 1);
      setNum2(Math.floor(Math.random() * 10) + 1);
      setAnswer("");
      return [false, answer];
    }
  };
  const numRefresh = () => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
    setAnswer("");
  };

  // Expose the checkAnswer function through the ref
  useImperativeHandle(ref, () => ({
    checkAnswer,
    numRefresh,
  }));

  return (
    <div className={classes.container}>
      {/* <Grid container direction="row" justifyContent="center">
        <Grid item xs={4} md={4} lg={4} className={classes.numBox}>
          <Typography variant="p">
            {num1} + {num2} = ?
          </Typography>
        </Grid>
        <Grid item xs={5} md={5} lg={5}>
          <TextField
            type="text"
            onChange={handleChange}
            value={answer}
            size="small"
            fullWidth
            className="inputRounded"
            error={Boolean(errorMsg)}
            helperText={errorMsg}
          />
          {/* <input type="text" onChange={handleChange} value={answer} /> */}
      {/* <button onClick={checkAnswer}>Submit</button> */}
      {/* </Grid>
      </Grid>  */}
      <Box className={classes.captchaBox}>
        {/* <Box className={classes.numBox}>
          <Typography variant="p">
            {num1} + {num2} = ?
          </Typography>
        </Box> */}
        <TextField
          type="text"
          onChange={handleChange}
          value={answer}
          size="small"
          fullWidth
          label="Enter the captcha"
          // label={<Typography variant="p">
          //   {num1} + {num2} = ?
          // </Typography>}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="p">
                  {num1} + {num2} = ?
                </Typography>
              </InputAdornment>
            ),
          }}
          className="inputRounded captchaInput"
          error={Boolean(errorMsg)}
          helperText={errorMsg}
        />
      </Box>
    </div>
  );
}

// Wrap the component with forwardRef
export default forwardRef(Captcha);
